define('core/utils/url/serialize',['require','exports','module','core/utils/url/serializeArgs'],function (require, exports, module) {
    'use strict';

    var serializeArgs = require('core/utils/url/serializeArgs');

    /**
     * Adds name:value pairs from object to the url's query string.
     *
     * @param {string} url - The base url. May already contain a query string.
     * @param {Object} [params] - The parameters to add.
     * @param {boolean} [nocache] - If true, a time-based parameter will be added to bust the cache.
     * @returns {string} - The url with parameters added.
     */
    module.exports = function serialize(url, params, nocache) {
        if (params) {
            if (url.indexOf('?') === -1)
                url += '?';
            else if (url.charAt(url.length - 1) !== '&')
                url += '&';

            url += serializeArgs(params);
        }

        if (nocache) {
            var ncp = {};
            ncp[(new Date()).getTime()] = null;
            return serialize(url, ncp);
        }

        var len = url.length;
        return url.charAt(len - 1) === '&' ? url.slice(0, len - 1) : url;
    };
});

